import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import { HAIRSTYLE_TAB_LIST } from '../../../../config/dataConfig/FJHairstyleChangerDataConfig';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJHairstyleListContainer from '../container/FJHairstyleListContainer';
import FJHairColorListContainer from '../container/FJHairColorListContainer';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput';
import FJAIHairstyleChangerConfig from '../../../../config/appConfig/FJAIHairstyleChangerConfig';
import FJHairColorPicker from '../view/FJHairColorPicker';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
} from '../../../../config/dataConfig/FJGenerateData.js';
import ExclamationIcon from '../../../../assets/svg/info.svg?react';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJHairstyleDemonstration from './FJHairstyleDemonstration.jsx';

import styles from './FJHairstyleChangerLeft.module.less';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';

function FJHairstyleChangerLeft({
    tab,
    onTabChange,
    onGenerate,
    taskStatus,
    freeNumCreation,
    isProjectLoading,
    creditNumber,
    hairColor,
    onSelectHairColor,
    peopleImageInfo,
    isDraggingFile,
    setIsDraggingFile,
    onUploadImg,
    openMediaLibrary,
}) {
    const isFree = freeNumCreation > 0 && creditNumber < FJAIHairstyleChangerConfig.unitPrice;
    const defaultFreeNumCreation = useDefaultFreeLimit();

    const _renderTrigger = config => {
        return (
            <div className={styles.icon} onClick={config.onClick} ref={config.ref}>
                <ExclamationIcon />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.desc} ref={config.ref}>
                <FJHairstyleDemonstration />
            </div>
        );
    };

    const _handleTabChange = useCallback(
        index => {
            // 防止tab未变重复触发
            index === tab || onTabChange(tab, index);
        },
        [onTabChange, tab],
    );

    return (
        <FJAppLeft className={styles.app_left}>
            <div className={styles.upload_box}>
                <div className={classNames(styles.upload_title, styles.is_require)}>
                    <div>{FJLocalStore._('upload')}</div>
                    <FJDropdownNew
                        isTopLayer={true}
                        renderTrigger={_renderTrigger}
                        useAnchorBody
                        placement='rightTop'
                        trigger='click'
                        renderOverlay={_renderOverlay}
                        offsetLeft={22}
                        offsetTop={-21}
                    />
                </div>
                <FJImageInput
                    uploadImageInfo={peopleImageInfo}
                    isDraggingFile={isDraggingFile}
                    uploadImg={onUploadImg}
                    acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                    setIsDraggingFile={setIsDraggingFile}
                    openMediaLibrary={openMediaLibrary}
                    style={{
                        height: '60px',
                        flex: 'none',
                    }}
                />
            </div>
            <div className={styles.hairstyle_title}>
                <div>{FJLocalStore._('style')}</div>
            </div>
            <FJMenuTab
                className={styles.tab_box}
                list={HAIRSTYLE_TAB_LIST}
                curIndex={tab}
                onChange={_handleTabChange}
            />
            {tab === 0 || tab === 1 ? <FJHairstyleListContainer /> : <FJHairColorListContainer />}
            <div className={styles.footer}>
                {tab !== 2 && <FJHairColorPicker value={hairColor} onSelect={onSelectHairColor} />}
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                    isFree={isFree}
                    useCredit={FJAIHairstyleChangerConfig.unitPrice}
                    isProjectLoading={isProjectLoading}
                />
            </div>
        </FJAppLeft>
    );
}

FJHairstyleChangerLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    tab: PropTypes.number,
    onTabChange: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    hairColor: PropTypes.object,
    onSelectHairColor: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    onUploadImg: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    peopleImageInfo: PropTypes.object,
    openMediaLibrary: PropTypes.func,
};

export default FJHairstyleChangerLeft;
